const ensureIntlTelInputStyle = () => {
  if (document.getElementById('iti-search-style')) return
  const style = document.createElement('style')
  style.id = 'iti-search-style'
  style.innerHTML = `.iti__search-input { padding-left: 2.5rem !important; }`
  document.head.appendChild(style)
}

const initPhoneInputs = () => {
  const phoneInputs = Array.from(document.querySelectorAll('input[id$="_phone"]'))
  if (phoneInputs.length === 0 || typeof window.intlTelInput !== 'function') return

  ensureIntlTelInputStyle()

  const options = {
    initialCountry: 'my',
    separateDialCode: true,
    autoPlaceholder: 'polite',
    preferredCountries: ['my', 'sg'],
    excludeCountries: ['il', 'kp'],
    nationalMode: false,
    loadUtils: () => import('https://cdn.jsdelivr.net/npm/intl-tel-input@25.10.10/build/js/utils.js')
  }

  phoneInputs.forEach(telInput => {
    const iti = window.intlTelInput(telInput, options)
    const form = telInput.form || document

    const updatePhoneValue = () => {
      const updatedFullPhone = iti.getNumber()
      telInput.value = updatedFullPhone
    }

    form.addEventListener('submit', updatePhoneValue)
  })
}

const initOtherInputs = () => {
  const otherInputs = document.querySelectorAll('input[id$="_other"]')

  otherInputs.forEach(otherInput => {
    const mainInputId = otherInput.id.replace('_other', '')
    const mainInput = document.getElementById(mainInputId)
    if (!mainInput) return

    const wrapper = otherInput.closest(`.${otherInput.id}`)
    if (!wrapper) return

    const toggleVisibility = () => {
      if (mainInput.tagName !== 'SELECT') return

      const selectedOption = mainInput.options[mainInput.selectedIndex]
      const text = selectedOption?.text?.toLowerCase() || ''
      const isOtherSelected = text.includes('other')

      if (isOtherSelected) {
        wrapper.classList.remove('hidden')
        otherInput.required = true
      } else {
        wrapper.classList.add('hidden')
        otherInput.required = false
        otherInput.value = ''
      }
    }

    mainInput.addEventListener('change', toggleVisibility)
    toggleVisibility()
  })
}

const parseMemberTypesData = memberTypeInput => {
  const raw = memberTypeInput.dataset.memberTypes
  if (!raw) return []

  try {
    return JSON.parse(raw)
  } catch (err) {
    console.warn('Unable to parse member types data', err)
    return []
  }
}

// BEGIN ENT SUMMIT 2026 (event-specific): profession -> member type mapping
const PROFESSION_TO_MEMBER_TYPE = {
  'ENT Specialist / Otorhinolaryngologist': 'Malaysian ENT Specialists',
  'Medical Officers/ Master Trainee': 'Malaysian Medical Officers/Master Trainees',
  Nurse: 'Malaysian Nurse',
  'General Practitioner': 'Malaysian Medical Officers/Master Trainees',
  Others: 'Malaysian ENT Specialists'
}
// END ENT SUMMIT 2026

// BEGIN AUDIOLOGY SUMMIT 2026 (event-specific): nationality -> member type mapping
const AUDIOLOGIST_MEMBER_TYPES = {
  malaysian: 'Malaysian Audiologist',
  international: 'International Audiologist'
}
// END AUDIOLOGY SUMMIT 2026

const initMemberTypeFilter = () => {
  const memberTypeInput = document.getElementById('user_member_type_id')
  const countryInput = document.getElementById('user_country')
  const professionInput = document.getElementById('user_profession')
  const memberTypeDisplay = document.getElementById('user_member_type_display')
  if (!memberTypeInput || !countryInput) return

  const memberTypesData = parseMemberTypesData(memberTypeInput)
  const autoAssignEnabled = memberTypeInput.dataset.memberTypeMode === 'readonly'
  const memberTypeContext = (memberTypeInput.dataset.memberTypeContext || '').toString().trim().toLowerCase()

  const normalizeValue = value => value.toString().trim().toLowerCase()

  const isMalaysianCountry = country => {
    if (!country) return false
    const normalized = country.toString().trim().toUpperCase()
    return normalized === 'MY' || normalized === 'MALAYSIA'
  }

  const findMemberTypeByName = name => {
    if (!name) return null
    const normalizedName = normalizeValue(name)
    return memberTypesData.find(memberType => normalizeValue(memberType.name) === normalizedName) || null
  }

  const filterMemberTypes = () => {
    const selectedCountry = countryInput.value

    Array.from(memberTypeInput.options).forEach(option => {
      if (!selectedCountry) {
        option.hidden = option.value !== ''
        option.disabled = option.value !== ''
        return
      }

      if (option.value === '') return

      const memberType = memberTypesData.find(mt => mt.id.toString() === option.value)
      if (!memberType) return

      let shouldShow = true

      if (memberType.country_rule === 'specific_countries') {
        shouldShow = memberType.countries.includes(selectedCountry)
      } else if (memberType.country_rule === 'exclude_countries') {
        shouldShow = !memberType.countries.includes(selectedCountry)
      }

      option.hidden = !shouldShow
      option.disabled = !shouldShow
    })
  }

  const isMemberTypeAllowedForCountry = (memberType, country) => {
    if (!memberType) return false
    if (memberType.country_rule === 'specific_countries') {
      return memberType.countries.includes(country)
    }
    if (memberType.country_rule === 'exclude_countries') {
      return !memberType.countries.includes(country)
    }
    return true
  }

  const setMemberType = memberType => {
    memberTypeInput.value = memberType ? memberType.id : ''
    if (memberTypeDisplay) {
      memberTypeDisplay.value = memberType ? memberType.name : ''
    }
  }

  const applyMemberType = () => {
    filterMemberTypes()
    if (memberTypeInput.disabled || !autoAssignEnabled) return

    // BEGIN ENT SUMMIT 2026 (event-specific): auto-assign registration category
    const selectedCountry = countryInput.value
    if (!selectedCountry) {
      setMemberType(null)
      return
    }

    let desiredMemberType = null

    if (memberTypeContext === 'audiologist') {
      const desiredMemberTypeName = isMalaysianCountry(selectedCountry)
        ? AUDIOLOGIST_MEMBER_TYPES.malaysian
        : AUDIOLOGIST_MEMBER_TYPES.international
      desiredMemberType = findMemberTypeByName(desiredMemberTypeName)
    } else {
      if (!isMalaysianCountry(selectedCountry)) {
        desiredMemberType = findMemberTypeByName('International Delegates')
      } else if (professionInput) {
        const desiredMemberTypeName = PROFESSION_TO_MEMBER_TYPE[professionInput.value]
        if (desiredMemberTypeName) {
          desiredMemberType = findMemberTypeByName(desiredMemberTypeName)
        }
      }
    }

    if (desiredMemberType && isMemberTypeAllowedForCountry(desiredMemberType, selectedCountry)) {
      setMemberType(desiredMemberType)
      return
    }

    setMemberType(null)
    // END ENT SUMMIT 2026
  }

  countryInput.addEventListener('change', () => {
    memberTypeInput.value = ''
    applyMemberType()
  })

  if (professionInput && memberTypeContext !== 'audiologist') {
    professionInput.addEventListener('change', applyMemberType)
  }

  applyMemberType()
}

const initMealPreferenceToggle = () => {
  const attendingWelcomeReceptionInput = document.getElementById('user_attending_welcome_reception')
  const mealPreferenceWrapper = document.querySelector('.user_meal_preference')
  const mealPreferenceInput = document.getElementById('user_meal_preference')
  const mealPreferenceOtherInput = document.getElementById('user_meal_preference_other')
  const mealPreferenceOtherWrapper = document.querySelector('.user_meal_preference_other')

  if (!attendingWelcomeReceptionInput || !mealPreferenceWrapper || !mealPreferenceInput || !mealPreferenceOtherInput) return

  const toggleMealPreference = () => {
    const selectedValue = (attendingWelcomeReceptionInput.value || '').toString().toLowerCase()
    if (selectedValue === 'true') {
      mealPreferenceWrapper.classList.remove('hidden')
      mealPreferenceInput.required = true
    } else {
      mealPreferenceWrapper.classList.add('hidden')
      mealPreferenceInput.required = false
      mealPreferenceInput.value = ''

      if (mealPreferenceOtherWrapper) {
        mealPreferenceOtherWrapper.classList.add('hidden')
      }
      mealPreferenceOtherInput.required = false
      mealPreferenceOtherInput.value = ''
    }
  }

// Uncomment to enable dynamic meal preference based on reception attendance
  // attendingWelcomeReceptionInput.addEventListener('change', toggleMealPreference)
  // toggleMealPreference()
}

const initUser = () => {
  const userForm = document.querySelector('form#new_user, form[id^="edit_user"]')
  if (!userForm) return

  initPhoneInputs()
  initOtherInputs()
  initMemberTypeFilter()
  initMealPreferenceToggle()
}

export default initUser
